import { Modal, Breadcrumb, Descriptions } from "antd";
import { HomeOutlined, FolderOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store/store";
import { resetPhaseInDetailModalSlice } from "../../../store/slices/projectManagement/phase-view/PhaseInDetailView";
import PhaseInDetailView from "./PhaseInDetailsView";
import dayjs from "dayjs";
import { Popconfirm } from "antd/lib";
import { Icon } from "../../../components/Component";
import { updateRootPageRenderState } from "../../../store/slices/projectManagement/project-view/ProjectInDetail";
import { useWbsName } from "../shared/useWbsCodes";
import { useEffect, useState } from "react";

const PhaseInDetailModal = () => {
  const dispatch = useDispatch();
  const [screenSize, setScreenSize] = useState(0);

  // Function to handle screen size changes
  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  const { data: PhaseInDetailModal } = useSelector(
    (state: RootState) => state.PhaseInDetailModal
  );
  const { id, open, phaseName, projectResponse, activeTab, extra } =
    PhaseInDetailModal;
  const wbsName = useWbsName();
  const { id: projectId, name: projectName } = projectResponse || {};
  const { data: RootPageRenderState } = useSelector(
    (state: RootState) => state.RootPageRenderState
  );

  // Handle breadcrumb click
  const handleProjectBreadcrumbClick = () => {
    dispatch(updateRootPageRenderState(!RootPageRenderState)); // call when exiting to root page
    dispatch(resetPhaseInDetailModalSlice());
  };

  // Handle screen size changes
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  return (
    <Modal
      className="detail-view-modal"
      maskClosable={false}
      title={
        <div className="d-flex justify-content-start align-items-center">
          <Breadcrumb
            items={[
              {
                title: <HomeOutlined />,
              },
              {
                title: (
                  <span
                    className="parent-nav"
                    onClick={handleProjectBreadcrumbClick}
                  >
                    <FolderOutlined style={{ marginRight: 4 }} />
                    {projectName}
                  </span>
                ),
              },
              {
                title: wbsName(phaseName),
              },
            ]}
          />
          <Popconfirm
            placement="right"
            title={<></>}
            icon={<></>}
            showCancel={false}
            trigger="hover"
            okButtonProps={{
              style: {
                display: "none",
              },
            }}
            description={
              <div className="d-flex flex-column">
                <Descriptions
                  title=""
                  bordered
                  column={1}
                  size="small"
                  className="custom-description-title"
                >
                  <Descriptions.Item label="Status">
                    {extra?.status}
                  </Descriptions.Item>
                  <Descriptions.Item label="Start Date">
                    {dayjs(extra?.startDate)?.format("DD-MMM-YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="End Date">
                    {dayjs(extra?.endDate)?.format("DD-MMM-YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="Owner">
                    {extra?.ownerName || "--"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {dayjs(extra?.createdAt)?.format("DD-MMM-YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created By">
                    {extra?.createdByUserName || "--"}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            }
          >
            <Icon
              name="info"
              className="ms-1"
              style={{
                cursor: "pointer",
              }}
            />
          </Popconfirm>
        </div>
      }
      style={{ top: 8 }}
      width={"99%"}
      animation={false}
      open={open}
      footer={null}
      onCancel={() => {
        dispatch(updateRootPageRenderState(!RootPageRenderState)); // call when exiting to root page
        dispatch(resetPhaseInDetailModalSlice());
        // switch (onClose) {
        // case "openProjectModal":
        //   dispatch(updateProjectInDetailModalSlice({ open: true }));
        //   break;
        //   default:
        //     dispatch(resetProjectInDetailModalSlice());
        // }
      }}
    >
      <PhaseInDetailView activeTab={activeTab} />
    </Modal>
  );
};

export default PhaseInDetailModal;
